import RestApi from './../../api/rest-api-client'
import StorageService from './Storage.service'
import TrackJsService from './TrackJs.service'
import { onAuthStateChanged, signInWithEmailAndPassword, signInWithCustomToken, signOut } from 'firebase/auth'
import { firebaseAuth } from '../../api/FirebaseAuth'
import { formatErrorMsg } from '../formatters/errorMsgFormatter'
// import firebase from 'firebase/app'
// import 'firebase/auth'
import PushNotificationsStore from './../../components/push/PushNotifications.store'

const authKeys = [
  'user_fb',
  'user_details',
  'user_token',
  'prev_url',
  'parent_name',
  'parent_id',
  'parent_usertype_id',
  'child_fb',
  'child_details',
  'child_assumed_at',
  'assume_id',
]
const assumedIdKeys = [
  'child_fb',
  'child_token',
  'parent_name',
  'parent_id',
  'parent_usertype_id',
  'child_details',
  'prev_url',
  'child_assumed_at',
  'assume_id',
]

const getMe = async () => {
  try {
    return await RestApi.request('GET', '/auth/me')
  } catch (ex) {
    return `${ex}`
  }
}

const getUserDetails = async isChild => {
  return new Promise((resolve, reject) => {
    let user
    getMe()
      .then(u => {
        StorageService.set(`${isChild ? 'child' : 'user'}_details`, (user = u))
        StorageService.set('modals.quote-popup', new Date().getTime())
      })
      .finally(() => {
        TrackJsService.onLogin()
        resolve(user)
      })
  })
}

const getToken = () => StorageService.getToken()

const setToken = token => StorageService.setToken(token)

let authChangeSubscription
async function obtainToken(isChild) {
  return new Promise((resolve, reject) => {
    const isc = isChild === true

    // unsubscribe if a handler function is defined.
    if (authChangeSubscription && typeof authChangeSubscription === 'function') {
      authChangeSubscription()
    }

    // this is an observer.  we need to kill
    // the subscription before re-subscribing.
    // Subscribe to Auth State Changes
    authChangeSubscription = onAuthStateChanged(firebaseAuth, user => {
      if (user) {
        // User is signed in, get the ID token
        user
          .getIdToken(true)
          .then(token => {
            StorageService.set(`${isc ? 'child' : 'user'}_token`, token)
            resolve() // Make sure to handle resolve appropriately if this is inside a promise
          })
          .catch(error => {
            console.error('Error getting ID token:', error)
            reject(error) // Reject the promise if there's an error
          })
      } else {
        // User is signed out, handle accordingly if needed
      }
    })
  })
}

const extractFbAuthToken = tokenStr => {
  let token, uid, assume_id
  try {
    if (typeof tokenStr === 'string') {
      tokenStr = JSON.parse(decodeURIComponent(atob(tokenStr)))
    }
    if (typeof tokenStr !== 'object') {
      tokenStr = {}
    }

    token = tokenStr && tokenStr?.token
    uid = tokenStr && tokenStr?.uid
    assume_id = tokenStr && tokenStr?.assume_id
  } catch (ex) {
    console.error('Fatal error attempting to decode auth token.', ex)
  }

  return { token, uid, assume_id }
}

const handleCredentialLogin = async (email, password, isChild) => {
  isChild = isChild === true
  return new Promise((resolve, reject) => {
    signInWithEmailAndPassword(firebaseAuth, email, password)
      .then(res => {
        StorageService.set(`${isChild ? 'child' : 'user'}_fb`, res.user)
        obtainToken(isChild).finally(() => getUserDetails(isChild).then(userDetails => resolve(userDetails)))
      })
      .catch(error => {
        reject(error.message)
      })
  })
}

const handleTokenLogin = async (token, uid, isChild) => {
  isChild = isChild === true
  return new Promise((resolve, reject) => {
    signInWithCustomToken(firebaseAuth, token)
      .then(res => {
        if (res.user?.uid === uid) {
          StorageService.set(`${isChild ? 'child' : 'user'}_fb`, res.user)
          return obtainToken(isChild).finally(() => getUserDetails(isChild).then(resolve))
        }
        reject(
          'Failed to collect user profile from upline service.  Please try again or contact support at website.support@usabg.com for further assistance.'
        )
      })
      .catch(error => {
        reject(error.message)
      })
  })
}

const login = async (email, password, user_ip, accept_terms) => {
  authKeys.forEach(k => StorageService.clear(k))

  const _login = async (email, password) => {
      try {
        const request = await RestApi.request('POST', '/auth/login', {
          email,
          password,
          user_ip,
          accept_terms,
        })

        return {
          email,
          password,
          access_token: request.access_token,
          terms_accepted: request.terms_accepted,
          error: null,
        }
      } catch (ex) {
        return { email, password, access_token: null, error: `${ex}` }
      }
    },
    { access_token, error, terms_accepted } = await _login(email, password)

  if (!error && access_token && access_token?.idToken) {
    const results = await new Promise((resolve, reject) => handleCredentialLogin(email, password).then(resolve, reject))

    // If the user has accepted sig agent terms recently,
    // update the local storage for sig agent terms. This will
    // prevent users from being inadvertantly prompted to
    // accept terms.
    return { ...results, terms_accepted: terms_accepted === true }
  }

  StorageService.clearAllKeys({
    except: [
      'modals.quote-popup',
      'modals.marketing-investment',
      'terms.login_sig_term_usertypes',
      'terms.login_sig_term_acceptance',
    ],
  })
  TrackJsService.track(new Error(error))
  throw new Error(error || 'Oh no! An error occured attempting to reach the server. Please try again soon.')
}

const validateAuthenticated = async () => {
  const result = await RestApi.request('GET', '/auth/validate')

  // ------------------------------------------------------------------
  // THIS FUNCTIONALITY IS NOT IN USE, NOT REQUIRED,
  // OR 100% COMPLETE. ENABLE WITH CAUTION!!
  //
  // let userDetails,
  // 		email;
  //
  // if (forceRefresh) {
  // 	userDetails 					=			StorageService.get('user_details');
  // 	userDetails 					= 		userDetails && typeof userDetails === 'string' ? JSON.parse(userDetails) : userDetails;
  // 	email 								=			userDetails && userDetails?.u_email;
  // }
  //
  // let result = forceRefresh === true
  // 								? await RestApi.request("POST", '/auth/validate', {email})
  // 								: await RestApi.request("GET", '/auth/validate', {email});
  // ------------------------------------------------------------------

  if (result && typeof result === 'object' && result?.id && result?.usertype_id) {
    return { id: result?.id, usertype_id: result?.usertype_id }
  }

  return false
}

const logout = async () => {
  // Invalidate this browser's push token BEFORE anything else. It must happen
  // while the Firebase token is still valid (the revoke call is authenticated)
  // and before storage is cleared. Otherwise a message meant for this agent
  // could still ring on a machine they have signed out of — a real risk on
  // shared or family computers.
  // releaseForLogout(), not disable() — signing out is not a preference, so it
  // must not record an opt-out that would leave this device muted on the next
  // sign-in.
  try {
    await PushNotificationsStore.releaseForLogout()
  } catch (ex) {
    console.error(`Failed to release push notifications on logout. ${ex}.`)
  }

  try {
    await RestApi.request('POST', '/auth/logout')
  } catch (ex) {
    console.error(`Failed to record tracking event. ${ex}.`)
  }

  StorageService.clearAllKeys({
    except: [
      'modals.quote-popup',
      'modals.marketing-investment',
      'terms.login_sig_term_usertypes',
      'terms.login_sig_term_acceptance',
      // Keep this browser's push identity and preferences across sign-outs.
      // Without deviceUid the machine accumulates a new device row on every
      // login; without optedOut, an agent who deliberately switched push off
      // would find it silently back on after their next sign-in.
      'usabg:push:deviceUid',
      'usabg:push:snoozedUntil',
      'usabg:push:optedOut',
    ],
  })

  return signOut(firebaseAuth).catch(error => error.message)
}

const sendResetPasswordLink = async email => {
  try {
    return await RestApi.request('POST', '/auth/password/send-link', { email })
  } catch (ex) {
    console.error('Failed to send reset password link. ', ex)
    throw Error(ex)
  }
}

const resetPassword = async (actionCode, apiKey, password) => {
  try {
    return await RestApi.request('POST', '/auth/password/reset', {
      actionCode,
      password,
      apiKey,
    })
  } catch (ex) {
    console.error('Failed to reset password. ', ex)
    throw Error(ex)
  }
}

const manualResetPassword = async (userId, password) => {
  try {
    return await RestApi.request('POST', '/auth/password/manual-reset', {
      user_id: userId,
      password,
    })
  } catch (ex) {
    console.error('Failed to reset password. ', ex)
    throw Error(ex)
  }
}

const assumeUser = async userId => {
  const _login = async userId => {
      let result
      try {
        result = await RestApi.request('POST', '/auth/assume/' + userId)
      } catch (ex) {
        result = `${ex}`
        return {
          user_id: userId,
          token: null,
          uid: null,
          assume_id: null,
          error: result,
        }
      }

      const { token, uid, assume_id } = extractFbAuthToken(result && result?.token)

      if (result && result?.status === 'success') {
        return { user_id: userId, token, uid, assume_id, error: false }
      }
      return { user_id: userId, token, uid, assume_id: null, error: result }
    },
    { token, uid, assume_id, error } = await _login(userId)

  if (token && uid) {
    let userDetails = StorageService.get('user_details')
    userDetails = userDetails && typeof userDetails === 'string' ? JSON.parse(userDetails) : userDetails

    // Track upcoming changes to local storage.
    let results,
      storage = {
        prev_url: `${window.location.pathname}${window.location.search}`,
        parent_name: `${userDetails?.u_fname} ${userDetails?.u_lname}`,
        parent_id: parseInt(userDetails?.id),
        parent_usertype_id: parseInt(userDetails?.usertype_id),
        assume_id,
      }

    try {
      results = await handleTokenLogin(token, uid, true)
    } catch (ex) {
      results = `${ex}`
      throw Error('Unable to assume as selected user. You are already assuming an agent')
    }

    if (results && typeof results === 'object' && results?.id) {
      StorageService.clear('user---required-alerts')
      StorageService.set('child_details', JSON.stringify(results))
      StorageService.set('child_assumed_at', new Date().getTime())

      Object.keys(storage).forEach(key => StorageService.set(key, storage[key]))

      return true
    }

    return false
  }
  throw Error(formatErrorMsg(error) || 'Unable to login as selected user.')
}

const unassumeUser = async () => {
  // 1. clear local storage values.
  // If NOTHING else goes right, this will force user to re-login.
  const path = StorageService.get('prev_url'),
    assumeId = StorageService.get('assume_id')
  assumedIdKeys.forEach(k => StorageService.clear(k))
  StorageService.clear('user---required-alerts')

  // 2. collect the (parent) user details & the unique assume_id.
  if (assumeId) {
    let attempt
    try {
      attempt = await RestApi.request('POST', '/auth/unassume/' + assumeId)
    } catch (ex) {
      return false
    }

    if (attempt && typeof attempt === 'object' && attempt?.token) {
      let { token, uid } = extractFbAuthToken(attempt && attempt?.token),
        results = false

      if (token && uid) {
        try {
          results = await handleTokenLogin(token, uid, false)
        } catch (ex) {
          results = `${ex}`
        }
      }

      if (results && typeof results === 'object' && results?.id) {
        return path ? `${path}`.trim() : '/dashboard'
      }
    }

    return false
  }

  // this is the fallback.
  let userDetails = StorageService.get('user_details')
  userDetails = userDetails && typeof userDetails === 'string' ? JSON.parse(userDetails) : userDetails

  const unassumed = await validateAuthenticated()
  if (unassumed && unassumed?.id && userDetails && userDetails?.id && `${unassumed.id}` === `${userDetails?.id}`) {
    return path ? `${path}`.trim() : '/dashboard'
  }

  return false
}

let refreshInFlight = null

const refreshToken = async () => {
  if (refreshInFlight) return refreshInFlight

  const doRefresh = () => {
    const user = firebaseAuth.currentUser
    if (user && user.uid) {
      return user.getIdToken(true).then(token => {
        setToken(token)
      })
    }
    return new Promise((resolve, reject) => {
      const unsub = onAuthStateChanged(firebaseAuth, u => {
        if (unsub && typeof unsub === 'function') unsub()
        if (!u || !u.uid) {
          reject('NO_USER')
          return
        }
        u.getIdToken(true)
          .then(token => {
            setToken(token)
            resolve()
          })
          .catch(reject)
      })
    })
  }

  refreshInFlight = doRefresh()
    .then(() => {
      refreshInFlight = null
    })
    .catch(err => {
      refreshInFlight = null
      throw err
    })
  return refreshInFlight
}

let redirectingToLogin = false
const redirectToLogin = () => {
  if (redirectingToLogin) return
  redirectingToLogin = true
  window.location.href = '/login'
}

const AuthService = {
  login,
  logout,
  assumeUser,
  unassumeUser,
  resetPassword,
  sendResetPasswordLink,
  getToken,
  refreshToken,
  redirectToLogin,
  validateAuthenticated,
  manualResetPassword,
}

export default AuthService
